import React, { useState } from 'react';
import Header from '../composant/ComposantAPP/Header';
import AdminPage from '../pages/AdminPage';
import Profil from '../pages/Profil';
import InfluenceursPage from '../pages/Influenceur';
import PreInscrit from '../pages/PreInscrit';
import PromouvoirPage from '../pages/Promouvoir';
import InscriptionValide from '../pages/InscriptionValider';
import AttenteValidation from '../pages/AttenteValidation';

const Dashboard = () => {
  const [activeSection, setActiveSection] = useState('preinscriptions');

  const renderContent = () => {
    switch (activeSection) {
      case 'admin':
        return (
          <>
            <AdminPage />
          </>
        );
      case 'preinscriptions':
        return (
          <>
         <PreInscrit />
          </>
        );
      case 'attenteValidation':
        return (
          <>
         <AttenteValidation />
          </>
        );
      case 'InscriptionValide':
        return (
          <>
         <InscriptionValide />
          </>
        );
      case 'influenceurs':
        return (
          <>
            <InfluenceursPage />
          </>
        );
      case 'Promouvoir':
        return (
          <>
            <PromouvoirPage />
          </>
        );
      default:
        return <p>Page en construction ...</p>;
    }
  };

  return (
    <div>
      <Header onMenuClick={setActiveSection} />
      <main style={{ padding: '2rem', fontFamily: 'Poppins, sans-serif' }}>
        {renderContent()}
      </main>
    </div>
  );
};

export default Dashboard;
